<template>
  <CalculatorScaffold />
</template>

<script>
import CalculatorScaffold from './components/CalculatorScaffold.vue'

export default {
  name: 'App',
  components: {
    CalculatorScaffold
  }
}
</script>

<style lang="scss">
  @import "~@/scss/main.scss";
</style>
